var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:_vm.refName,class:_vm.inputClass,attrs:{"id":_vm.id,"type":_vm.type,"name":_vm.name,"placeholder":_vm.placeholder,"required":_vm.required,"readonly":""},domProps:{"value":_vm.formattedValue},on:{"click":_vm.onClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }